import { memo, ReactElement, useEffect, useMemo } from "react";
import { OpenFeatureReactProvider, useStatus } from "@utilitywarehouse/feature-flags-react";
import { UWOpenFeatureProvider } from "@utilitywarehouse/feature-flags-provider";
import { UWFeatureFlagsApiClient } from "@utilitywarehouse/feature-flags-api-client";
import { OpenFeature, ProviderStatus } from "@openfeature/web-sdk";

import { env } from "../../env";
import { useAuthContext } from "../../context/auth/useAuthContext";

const project = "web";

const environment = env.isProductionHost ? "prod" : "dev";
const featureHost = `https://my-account-ff.${environment}.uw.systems`;

const apiClient = new UWFeatureFlagsApiClient(featureHost, project);
const client = OpenFeature.getClient();

const FeatureFlagProvider: React.FC<{ children: ReactElement }> = ({ children }) => {
  const { token } = useAuthContext();

  const provider = useMemo(() => new UWOpenFeatureProvider(apiClient, true, token), [token]);

  useEffect(() => {
    OpenFeature.setProvider(provider);
  }, [provider]);

  const status = useStatus(client, provider);

  if (status === ProviderStatus.NOT_READY) {
    return null;
  }

  return (
    <OpenFeatureReactProvider provider={provider} client={client}>
      {children}
    </OpenFeatureReactProvider>
  );
};

export default memo(FeatureFlagProvider);
